import { Container } from "Components/Container"
import { Column, Row } from "Components/Grid"
import { useTranslation } from "react-i18next"

export const NoPermission = () => {
    const { t } = useTranslation(['user']);
    return (
        <Container>
            <Row>
                <Column xs={12}>
                    <h2>{t('user:noPermission.message')}</h2>
                </Column>
            </Row>
        </Container>
    )
}